// ============================================================
//   API MANZILI — FAQAT SHU YERDAN O'ZGARTIRILADI (yagona joy)
// ============================================================
//
// Qaysi backenddan ma'lumot olishni shu yerda tanlaysiz.
// Kerakli qatorni qoldiring, ikkinchisini // bilan izohga oling.

// 🌐 Jonli (production) server:
export const API_URL = "https://api.svqt.uz";

// 💻 Lokal test (o'z kompyuteringizdagi backend):
// export const API_URL = "http://localhost:3033";

// ---
// Bonus: kod o'zgartirmasdan brauzer konsolidan vaqtincha almashtirish:
//   localStorage.setItem("API_URL", "http://localhost:3033"); // so'ng sahifani yangilang
//   localStorage.removeItem("API_URL");                        // standartga qaytarish
export const RESOLVED_API_URL =
  (typeof localStorage !== "undefined" && localStorage.getItem("API_URL")) ||
  API_URL;
